'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _mark = require('linksoft-albatros/src/modules/mark');

var _mark2 = _interopRequireDefault(_mark);

var _reactRedux = require('react-redux');

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = {
    value: '',
    currentIndex: 0,
    currentRow: 0,
    rowLength: 0
};

function mapStateToProps(state) {
    return {
        items: state.cart.items
    };
}

var CartItemHighlighter = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = function (_Component) {
    (0, _inherits3.default)(CartItemHighlighter, _Component);

    function CartItemHighlighter(props) {
        (0, _classCallCheck3.default)(this, CartItemHighlighter);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CartItemHighlighter.__proto__ || (0, _getPrototypeOf2.default)(CartItemHighlighter)).call(this, props));

        _this.onChange = function (e) {
            _this.setState((0, _extends3.default)({}, defaultState, { value: e.target.value }));
        };

        _this.goNext = function () {
            _this.move(1);
        };

        _this.goPrev = function () {
            _this.move(-1);
        };

        _this.clearAll = function () {
            _this.setState((0, _extends3.default)({}, defaultState));
        };

        _this.content = document.querySelector(".userInfo .products-view-table tbody");
        _this.results = (0, _jquery2.default)();
        _this.offsetTop = 300;

        _this.state = (0, _extends3.default)({}, defaultState);

        _this.contentMark = new _mark2.default(_this.content);
        return _this;
    }

    (0, _createClass3.default)(CartItemHighlighter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var $cartMark = (0, _jquery2.default)(document).find('.cart__mark');

            this.sticky($cartMark);
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            var _this2 = this;

            // changing steps
            if (this.state.currentIndex !== nextState.currentIndex || this.state.currentRow !== nextState.currentRow || this.state.value !== nextState.value || this.props.items.map(function (i) {
                return i.id;
            }).join() !== nextProps.items.map(function (i) {
                return i.id;
            }).join()) {
                setTimeout(function () {
                    _this2.jumpTo();
                }, 10);
            }
            if (this.state.value !== nextState.value || this.props.items !== nextProps.items) {
                this.searchAndMark(nextState.value);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                value = _state.value,
                currentRow = _state.currentRow,
                rowLength = _state.rowLength;


            if (value) {
                return _react2.default.createElement(
                    'div',
                    { className: 'cart__mark' },
                    _react2.default.createElement('input', { value: value || '', onChange: this.onChange, type: 'text' }),
                    _react2.default.createElement(
                        'span',
                        { className: 'cart-mark__count' },
                        '(',
                        currentRow || 0,
                        ' / ',
                        rowLength || 0,
                        ')'
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'btn btn-sm', onClick: this.goPrev },
                        _react2.default.createElement('i', { className: 'fa fa-angle-up' })
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'btn btn-sm', onClick: this.goNext },
                        _react2.default.createElement('i', { className: 'fa fa-angle-down' })
                    ),
                    _react2.default.createElement(
                        'button',
                        { onClick: this.clearAll, className: 'btn btn-sm close' },
                        _react2.default.createElement('i', { className: 'fa fa-close' })
                    )
                );
            } else {
                return _react2.default.createElement(
                    'div',
                    { className: 'cart__mark static' },
                    _react2.default.createElement('input', { value: value || '', onChange: this.onChange, type: 'text', placeholder: (0, _localize2.default)("App:CartMartInput") })
                );
            }
        }
    }, {
        key: 'move',
        value: function move(direction) {
            var results = this.results;
            var _state2 = this.state,
                currentIndex = _state2.currentIndex,
                currentRow = _state2.currentRow;


            if (results.length) {
                currentIndex += direction;

                if (currentIndex < 0) {
                    currentIndex = results.length - 1;
                }

                if (currentIndex > results.length - 1) {
                    currentIndex = 0;
                }
                currentRow = (0, _jquery2.default)(this.content).find('mark').eq(currentIndex).closest('tr').index('.tr--has-mark') + 1;
                this.setState((0, _extends3.default)({}, this.state, { currentIndex: currentIndex, currentRow: currentRow }));
            }
        }
    }, {
        key: 'searchAndMark',
        value: function searchAndMark(value) {
            var _this3 = this;

            var rowLength = this.state.rowLength;

            var currentRow = 0;
            if (value.length) {
                // init markjs
                this.contentMark.unmark({
                    done: function done() {
                        _this3.contentMark.mark(value, {
                            separateWordSearch: true,
                            exclude: [
                            // exclude all expect ean and title/autors
                            '.car-amount *', '.text-right', // very very bad selection :D
                            '.text-right *', '.text-center *'],
                            done: function done() {
                                _this3.results = (0, _jquery2.default)(_this3.content).find('mark');

                                // make row visible
                                (0, _jquery2.default)(document).find('.tr--has-mark').removeClass('tr--has-mark');
                                _this3.results.each(function () {
                                    (0, _jquery2.default)(this).closest('tr').addClass('tr--has-mark');
                                });
                                // count row

                                rowLength = (0, _jquery2.default)(document).find('.tr--has-mark').length;
                                if (rowLength > 0) {
                                    currentRow = 1;
                                }
                            }
                        });
                    }
                });
            } else {
                (0, _jquery2.default)(document).find('.tr--has-mark').removeClass('tr--has-mark');
                (0, _jquery2.default)(document).find('.has-mark--active').removeClass('has-mark--active');
                this.contentMark.unmark();
                (0, _jquery2.default)(document).find('.cart__mark').addClass('static');
                //$("html, body").stop().animate({scrollTop: 0}, 400);
            }

            setTimeout(function () {
                _this3.setState((0, _extends3.default)({}, _this3.state, { currentIndex: 0, currentRow: currentRow, rowLength: rowLength }));
            }, 10);
        }
    }, {
        key: 'jumpTo',
        value: function jumpTo() {
            if (this.results.length) {
                var currentIndex = this.state.currentIndex;

                var $current = (0, _jquery2.default)(this.results).eq(currentIndex);

                (0, _jquery2.default)(this.content).find('.has-mark--active').removeClass('has-mark--active');
                (0, _jquery2.default)(this.content).find('.mark__active').removeClass('mark__active');

                if ($current.length) {
                    // set active row
                    $current.closest('tr').addClass('has-mark--active');

                    $current.addClass('mark__active');

                    var position = $current.offset().top - this.offsetTop;
                    (0, _jquery2.default)("html, body").stop().animate({ scrollTop: position }, 400);
                }
                // let it move
                (0, _jquery2.default)(document).find('.cart__mark').removeClass('static');
            }
        }
    }, {
        key: 'sticky',
        value: function sticky($cartMark) {
            var headerHeight = (0, _jquery2.default)('.navbar-tshop').height();
            var cartMarkOffsetTop = $cartMark.offset().top - headerHeight;

            var init = function init() {
                if ((0, _jquery2.default)(window).scrollTop() >= cartMarkOffsetTop) {
                    $cartMark.css({
                        top: headerHeight
                    });
                    $cartMark.parent().addClass('sticky');
                } else {
                    $cartMark.attr('style', '');
                    $cartMark.parent().removeClass('sticky');
                }
            };

            (0, _jquery2.default)(window).on('scroll', init);
            init();
        }
    }]);
    return CartItemHighlighter;
}(_react.Component)) || _class);
exports.default = CartItemHighlighter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/CartItemHighlighter.js
// module id = 899
// module chunks = 0